import styled from "styled-components";

export const FavoritesPageContainer = styled.div`
	box-sizing: border-box;
	min-height: 100vh;
	display: grid;
	place-items: center;
	padding: 100px 0 0 0;
  background: #fff;

	@media (max-width: 991px) {
		padding-top: 55px;
	}
`;

export const PageWrapper = styled.div`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	min-height: 100%;
	margin: 0 auto;
	display: flex;
`;

export const FavoritesHeader = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.75rem 2.25rem;

	.favorites-title {
		flex: 1;
		display: inline-block;
		text-align: center;
		font-size: clamp(1.4rem, 3vw, 1.15rem);
		font-weight: 600;
	}

	.total-items-count,
	.empty-button-label {
		// font-weight: bold;
	}

	@media screen and (max-width: 576px) {
		padding: 0.5rem;

		.campaign-title {
			font-size: 1.025rem;
		}
	}
`;

export const Title = styled.div`
	display: block;
	font-size: 2rem;
	font-weight: 500;
	color: #28a745;
`;

export const FavoriteItemsWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(342px, 1fr));
	gap: 0.75rem;
	padding: 0 2.25rem 0.75rem 2.25rem;
	background: #fff;

	@media screen and (max-width: 576px) {
		gap: 0.5rem;
		padding: 0.5rem;
	}
`;

export const FavoriteItemContent = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: stretch !important;
	gap: clamp(0.75rem, 5vw, 0.5rem);
	padding: clamp(0.75rem, 5vw, 0.5rem);
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	border-radius: inherit;
	background: #ffffff;

	.btn-remove-favorite {
		z-index: 9;
		position: absolute;
		top: clamp(0.7rem, 5vw, 0.5rem);
		right: clamp(0.7rem, 5vw, 0.5rem);
		width: 30px;
		height: 30px;
		border-radius: 30px;
		display: grid;
		place-content: center;

		.favorite-icon {
			color: #9cc54b;
		}
	}
	&.express .btn-remove-favorite .favorite-icon {
		color: #f01266;
	}
`;

export const ImageContent = styled.div`
	position: relative;
	display: gird;
	place-content: center;
	width: clamp(150px, 5vw, 100px);
	// height: clamp(105px, 5vw, 65px)
	cursor: pointer;

	img {
		display: block;
		width: 100%;
		height: 100%;
		aspect-ratio: 3/4;
		object-fit: contain;
	}

  @media screen and (max-width: 520px) {
		width: clamp(125px, 5vw, 100px);
	}
`;

export const BrandLogoWrapper = styled.div`
	height: 35px;
	width: 35px;
	position: absolute;
	z-index: 1;
	top: 0px;
	left: 0px;
	border-radius: 50%;
	border: 1px solid rgb(236, 236, 236);
	display: grid;
	place-items: center;

	img {
		display: inline-block;
		height: 33px;
		width: 33px;
		border-radius: 50%;
		aspect-ratio: 3/4;
		object-fit: contain;
		mix-blend-mode: color-burn;
	}
	.brand-image {
		max-height: 35px;
		width: auto;
	}
	.brand-promo {
		max-height: 35px;
		width: auto;
	}
`;

export const ItemInfo = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;

	.stock-and-sku {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		column-gap: 0.5rem;
		flex-wrap: wrap;

		.stock-label,
		.sku-label {
			font-size: 0.875rem;
			span {
				font-size: 0.875rem;
				color: #9cc54b;
				font-weight: 500;

				&.express {
					color: #f01266;
				}
			}
		}

		@media (max-width: 450px) {
			.stock-label,
			.sku-label {
				font-size: 0.625rem;
				span {
					font-size: 0.625rem;
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin-bottom: 5px;

	span {
		padding: 0px 5px;
		color: #ffffff;
		font-size: 10px;
		line-height: 1.7;
		border-radius: 2px;

		&.sameDay-banner {
			background: #9cc54b;

			&.express {
				background: #f01266;
			}
		}

		&.tomorrow-banner {
			background: #fd7e14;
		}

		&.promo-banner {
			background: #dc3545;
		}

		&.out-of-stock-banner {
			background: #dc3545;
		}
	}
`;

export const ItemTitle = styled.p`
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.25;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	cursor: pointer;
	margin-right: 2rem;

	@media (max-width: 450px) {
		line-height: 1.25;
		font-size: 0.85rem;
	}
`;

export const WeightAndCountryWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 1rem;
	font-size: 1rem;

	@media (max-width: 450px) {
		font-size: 0.65rem;
		gap: 0.5rem;
	}
`;

export const PriceAndButtonActions = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	gap: 0.5rem;
	margin-top: auto;

	.btn-add-to-cart {
		transition: 0.3s;

		&:hover {
			background: #ffffff !important;
			color: #9cc54b !important;
			border-color: #9cc54b;
			& > * {
				fill: #9cc54b;
			}

			&.express {
				color: #f01266 !important;
				border-color: #f01266;
				& > * {
					fill: #f01266;
				}
			}
		}
	}
`;

export const ProductPriceWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;
	flex-shrink: 0;
	// margin-top: auto;

	.price {
		font-size: clamp(1.075rem, 3vw, 1rem) !important;
	}
`;

export const ProductPrice = styled.span`
	font-family: "Lato", sans-serif;
	font-size: clamp(1rem, 5vw, 0.875rem);
	font-weight: bold;
	color: #9cc54b;

	&.express {
		color: #f01266;
	}

	span {
		color: #9cc54b;

		&.express {
			color: #f01266;
		}
	}
`;

export const PromoPrice = styled.span`
	font-family: "Lato", sans-serif;
	font-size: clamp(1rem, 5vw, 0.875rem);
	font-weight: bold;
	color: #fbb979;
	display: inline-block;
`;

export const SpinnerWrapper = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	padding: 1rem;
`;

export const EmptyFavoritesContent = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	// background: red;
	flex-direction: column;
	gap: 1rem;
	padding-bottom: 4rem;
  padding-top: 1rem;

	.empty-favorites-image {
		display: inline-block;
		width: 15.625rem;
		height: auto;
		object-content: contain;
	}

	.empty-favorites-title {
		font-size: 1.25rem;
		font-weight: 600;
	}

	.start-browsing-btn {
		color: #9cc54b;
		font-size: 1rem;

		button {
			display: flex;
			gap: 0.25rem;
			color: #9cc54b;

			&:active {
				color: #9cc54b !important;
			}
		}

		&.express {
			color: #f01266;

			button {
				color: #f01266;

				&:active {
					color: #f01266 !important;
				}
			}
		}
	}
`;

export const IconCartContainer = styled.span`
	width: 14px;
	height: 14px;
	display: flex;
	align-items: center;
	fill: #fff;
`;

export const TitleFavorites = styled.p`
	@media screen and (max-width: 612px){
		font-size: 16px !important;
	}
`;

export const TitleFavoritesCount = styled.span`
	@media screen and (max-width: 612px){
		font-size: 14px !important;
	}
`;

export const FavoritesEmpty = styled.span`
	@media screen and (max-width: 612px){
		font-size: 14px !important;
	}
`;

export const FavoritesViewAll = styled.a`
	@media screen and (max-width: 612px){
		font-size: 14px !important;
	}
`;